import { Fragment } from "react";
//import styles from "./ReservationPage.module.css";
import ReservationForm from "./ReservationForm/ReservationForm";

const ReservationPage = () => {
  return (
    <Fragment>
      <ReservationForm />
    </Fragment>
  );
};
export default ReservationPage;
